import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import type { MapViewProps } from '@/components/maps/MapView';
import MapSkeleton from '../skeletons/MapSkeleton';

const MapView = dynamic(() => import('@/components/maps/MapView'), { loading: MapSkeleton, ssr: false });

export default function MapViewLoader(props: MapViewProps) {
  const [show, setShow] = useState(false);

  const searchParams = useSearchParams();
  const isMapView = searchParams.get('view') === 'MAP';
  const { isTablet, isMobile } = useBreakpoints();

  // only figure out if we should load them map client side (not during ssr)
  // then dynamically load the map component if it is needed.
  useEffect(() => {
    setShow((!isTablet && !isMobile) || isMapView);
  }, [isTablet, isMobile, isMapView]);

  return <>{show ? <MapView {...props} /> : <MapSkeleton />}</>;
}
